export enum TypeSummary {
  Tabs,
  List,
}
